import { Suspense, lazy, useContext, useEffect } from "react";
import Download from "../components/Download";
import { useSearchParams } from "react-router-dom";
import { Apicontext } from "../context/ContextApi";
import { useNavigate } from "react-router-dom";

const Footer = lazy(() => import("../components/Footer"));
const Faqs = lazy(() => import("../components/Faqs"));
const Header = lazy(() => import("../components/Header"));
const About = lazy(() => import("../components/About"));
const Main = lazy(() => import("../components/Main"));

const DownloadPage = () => {
  const { ApiData } = useContext(Apicontext);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const getVideoData=async () => {
    if (searchParams.get("url")) {
      const resp=await ApiData({ url: searchParams.get("url") });
      if(!resp){
        navigate("/")
      }
     } else {
       navigate("/");
     }
  }
  useEffect(() => {
    getVideoData()
  }, []);

  return (
    <div>
      <Suspense
        fallback={
          <div className="bg-white fixed z-50 top-0 left-0 right-0 h-[72px]"></div>
        }
      >
        <Header />
      </Suspense>
      <Suspense
        fallback={
          <div className="relative top-10 bg-[#0070D7] text-white font-roboto w-full min-h-[400px] flex items-center"></div>
        }
      >
        <Main disableInput={true} />
      </Suspense>
      <Download />
      <Suspense fallback={<div className="">Loading</div>}>
        <About />
      </Suspense>
      <Suspense fallback={<div className="">Loading</div>}>
        <Faqs />
      </Suspense>
      <Suspense fallback={<div className="">Loading</div>}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default DownloadPage;
